import dynamic from "next/dynamic";

export const DynamicHero063 = dynamic(() => import("./Hero063"), {
  suspense: true,
});
